import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorType,
  DataResponse,
  ErrorsResponse,
  SessionError,
  ApplicationError,
  ServerError,
  UserData,
  LogData,
  AppSession
} from '../models/';


@Injectable({
  providedIn: 'root'
})
export class PasswordRecoveryService {

  private rootPath = '/';
  private appManagerPath = 'am/';

  constructor(
    private httpClient: HttpClient,
    private userData: UserData
  ) { }

  private checkEndPoints() {
    // console.log('appManager: ', AppSession.getAppPath());
    // console.log('endPoints: ', AppSession.getEndPoints());

    if (AppSession.getAppPath() === '') {
      return throwError(ErrorType.UnexpectedErrorMessage);
    }
  }

  private getHeaders() {
    return new HttpHeaders()
      .set('content-type', 'application/json');
  }

  // write log
  public log(identityType: string, messageKey: string, param0: string, param1: string): Observable<any> {
    this.checkEndPoints();

    console.log('log: ' + this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().log);

    return this.httpClient
      .request('post',
        this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().log,
        {
          body: JSON.stringify(new LogData(
            LogData.priorityOK,
            LogData.logtypePublic,
            '',
            identityType,
            '',
            LogData.logexecOK,
            messageKey,
            param0,
            param1
          )),
          headers: this.getHeaders()
        }
      )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // change password request
  public changePasswordRequest(identification: string, captchaToken: string): Observable<any> {
    this.checkEndPoints();

    console.log('Send ' + identification + ':' + captchaToken);
    console.log('changePasswordRequest: ' + this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().passwordChangeRequest);

    return this.httpClient
      .request('post',
        this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().passwordChangeRequest,
        {
          body: {
            id: identification,
            captcha: captchaToken
          }
        }
      )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // validte token
  public validateTokenRequest(changePasswordToken: string): Observable<any> {
    this.checkEndPoints();

    console.log('validateTokenRequest: ' + this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().validateToken);

    return this.httpClient
      .request('post',
        this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().validateToken,
        {
          body: { token: changePasswordToken }
        }
      )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // validate password
  public validatePassword(pwd: string): Observable<any> {
    this.checkEndPoints();

    console.log('validatePassword: ' + this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().validatePassword);

    return this.httpClient
      .request('post',
        this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().validatePassword,
        {
          body: {
            username: this.userData.username,
            password: pwd,
            tokensession: this.userData.tokensession
          }
        }
      )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // change password
  public changePassword(pwd: string): Observable<any> {
    this.checkEndPoints();

    console.log('changePassword: ' + this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().changePassword);

    return this.httpClient
      .request('post',
        this.rootPath + this.appManagerPath + AppSession.getAppPath() + AppSession.getEndPoints().changePassword,
        {
          body: {
            username: this.userData.username,
            password: pwd,
            tokensession: this.userData.tokensession
          }
        }
      )
      .pipe(map(this.getData), catchError(this.handleError));
  }

  // handle data
  private getData(response: DataResponse) {
    return response;
  }

  // handle error
  private handleError(httpError: ErrorsResponse) {
    console.error('HTTP Status: ' + httpError.status);
    // console.error(httpError.error.errors);

    let errorMessage = '';
    if (httpError.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${httpError.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${httpError.status}\nMessage: ${httpError.message}`;
    }

    console.error(errorMessage);

    if (httpError.error.errors === undefined) {
      console.warn(httpError);
    } else {
      console.error(httpError.error.errors);
      httpError.error.errors.forEach(
        (e: ErrorType) => {
          console.error('code: ' + e.code + ':' + e.message);
        });
    }

    switch (httpError.status) {
      case ErrorType.Unauthorized: return throwError(new SessionError(''));
      case ErrorType.BadRequest: return throwError(new ApplicationError('', httpError.error.errors));
      case ErrorType.InternalServerError: return throwError(new ServerError('', httpError.error.errors));
      default: return throwError(ErrorType.UnexpectedErrorMessage);
    }
  }
}
